import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";


const AddAttributeForm = (props: any) => {
    const { staticFormFields, formAttribute, formAtrributes, setFormAttributes } = props
    const [fieldKey, setFieldKey] = useState(staticFormFields?.[0]?.attributeKey || "")
    const [fieldType, setFieldType] = useState("")
    const [fieldValue, setFieldValue] = useState("")
    const [showFileUploadField, setShowFileUploadField] = useState(false)
    const [showTextField, setShowTextField] = useState(false)
    const [showBooleanField, setShowBooleanField] = useState(false)
    const [fileName, setFileName] = useState("")

    const fieldKeyOptions = useMemo(
        () => (staticFormFields || []).map((d: any) => ({ "value": d.attributeKey, "label": d.attributeKey })),
        [staticFormFields])

    //change fieldType as per fieldKey
    useEffect(() => {
        if (fieldKey) {
            const attribute = staticFormFields.find((s: any) => s.attributeKey == fieldKey)
            if (attribute) {
                //File upload
                if ([27, 28].includes(attribute.id)) {
                    setShowFileUploadField(true)
                    setShowBooleanField(false)
                    setShowTextField(false)
                }
                //Boolean
                else if ([12, 18, 19].includes(attribute.id)) {
                    setShowBooleanField(true)
                    setShowFileUploadField(false)
                    setShowTextField(false)
                }
                //Text
                else {
                    setShowTextField(true)
                    setShowFileUploadField(false)
                    setShowBooleanField(false)
                }
                setFieldType(attribute.attributeType)
            }

        }
    }, [fieldKey])

    useEffect(() => {
        if (fieldValue && fieldKey && fieldType) {
            const attribute = staticFormFields.find((s: any) => s.attributeKey == fieldKey)
            if (attribute) {
                const currentAttributeIndex = formAtrributes.findIndex((d: any) => d.id === formAttribute.id)
                if (currentAttributeIndex !== -1) {
                    let tempHolder = formAtrributes[currentAttributeIndex]
                    formAtrributes[currentAttributeIndex] = {
                        "id": tempHolder["id"],
                        "attributeKeyId": attribute["id"],
                        "attributeValue": fieldValue
                    }
                    setFormAttributes([...formAtrributes])
                }
                else {
                    formAtrributes[0]["attributeKeyId"] = attribute["id"]
                    formAtrributes[0]["attributeValue"] = fieldValue
                    setFormAttributes([...formAtrributes])
                }
            }
        }
    }, [fieldKey, fieldType, fieldValue])

    const imagehandler = (e: any) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            setFieldValue(img);
            setFileName(img.name)
        }
    };

    return (<>
        <div className="field-row flex flex-wrap">
            <div className="form-field field-key">
                <label>Field Key</label>
                {/* The key list runs long, so it is typed into rather than scrolled */}
                <Select
                    className="key-select"
                    classNamePrefix="key-select"
                    options={fieldKeyOptions}
                    value={fieldKeyOptions.find((o: any) => o.value === fieldKey) || null}
                    onChange={(option: any) => setFieldKey(option?.value || "")}
                    placeholder="Search field key.."
                    isSearchable={true}
                    //The panel scrolls, a menu rendered inside it would be clipped
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }} />
            </div>

            <div className="form-field field-type">
                <label>Field Type</label>
                {/* Derived from the key, so it is shown rather than asked for */}
                <div className="read-only-value">{fieldType || "—"}</div>
            </div>
        </div>

        {showFileUploadField &&
            <div className="form-field">
                <label>Choose File</label>
                <input onChange={imagehandler} accept=".jpg,.png,.jpeg" type="file" />
                {fileName ? <p className="field-hint">{fileName}</p> : <p className="field-hint">JPG or PNG, uploaded when the component is saved.</p>}
            </div>
        }

        {showBooleanField &&
            <div className="form-field">
                <label>Field Value</label>
                <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} >
                    <option value="">Select</option>
                    <option value="true" >True</option>
                    <option value="false" >False</option>
                </select>
            </div>
        }

        {
            showTextField &&
            <div className="form-field">
                <label>Field Value</label>
                <input value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} type="text" placeholder="Enter value here.." />
            </div>
        }
    </>)
}

export default AddAttributeForm
